import { render, staticRenderFns } from "./ProjectDetailModule.vue?vue&type=template&id=0f93fff6&scoped=true&"
import script from "./ProjectDetailModule.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailModule.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailModule.vue?vue&type=style&index=0&id=0f93fff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93fff6",
  null
  
)

export default component.exports